import { t } from 'i18next'
import ResultBase from '../ResultBase'
import styles from './Answer.module.css'

interface AnswerProps {
  data: string
  title: string
}

const Answer = ({ data, title }: AnswerProps) => {
  return (
    <ResultBase title={title}>
      <div className={styles.container}>
        <div className={styles.answer}>
          <div className={styles.answerHeader}>{t('results.answer')}</div>
          {data}
        </div>
      </div>
    </ResultBase>
  )
}

export default Answer
